import { BlocksIconCreditCard } from 'blocks-nextjs/blocks-web-components/components/icon/icons/credit-card';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconCreditCard = createComponent({
  react: React,
  tagName: 'cat-icon-credit-card',
  elementClass: BlocksIconCreditCard
});
